import React, { useState } from "react";
import { useParams } from "react-router-dom";
import NavBar from "../components/navBar/NavBar";
import FooterComponent from "../components/footer/FooterComponent";
import { phases } from "../data/data";

const Register = () => {
  const { id } = useParams();
  const phase = phases.find((p) => String(p.id) === id);

  const [childName, setChildName] = useState("");
  const [parentName, setParentName] = useState("");
  const [dob, setDob] = useState("");
  const [phone, setPhone] = useState("");

  if (!phase) return <div style={{ padding: 20 }}>Course not found</div>;

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `*Learner Registration Form*\n
Child Name: ${childName}
Parent Name: ${parentName}
Date of Birth: ${dob}
Phone Number: ${phone}
Course Phase: ${phase.title} (Phase ID: ${phase.id})

Please confirm the registration details.`;

    const url = `https://wa.me/918531966231?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div
      style={{
        // minHeight: "100vh",
        background: "#121212",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <NavBar />

      <div
        style={{
          maxWidth: 500,
          margin: "100px auto",
          padding: "28px",
          background: "#000000",
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <h2
          style={{
            fontSize: 18, 
            marginBottom: 40,
            textAlign: "center",
            color: "burlywood",
            fontFamily: "Nexa-Regular",
          }}
        >
          Register for {phase?.title || "Course Phase"}
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontFamily: "Nexa-Bold", color: "#fff" }}>
              Child Name
            </label>
            <input
              type="text"
              name="childName"
              required
              value={childName}
              onChange={(e) => setChildName(e.target.value)}
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ fontFamily: "Nexa-Bold", color: "#fff" }}>
              Parent Name
            </label>
            <input
              type="text"
              name="parentName"
              required
              value={parentName}
              onChange={(e) => setParentName(e.target.value)}
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ fontFamily: "Nexa-Bold", color: "#fff" }}>
              Date of Birth
            </label>
            <input
              type="date"
              name="dob"
              required
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ fontFamily: "Nexa-Bold", color: "#fff" }}>
              Phone Number
            </label>
            <input
              type="tel"
              name="phone"
              required
              pattern="[0-9]{10}"
              placeholder="Enter 10-digit phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              style={inputStyle}
            />
          </div>

          <button type="submit" style={buttonStyle}>
            Send via WhatsApp
          </button>
        </form>
      </div>

      <FooterComponent />
    </div>
  );
};

export default Register;

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  fontSize: 15,
  borderRadius: 8,
  border: "1px solid #ccc",
  marginTop: 6,
  fontFamily: "Nexa-Regular",
  marginBottom: 20,
  color: "whitesmoke",
  backgroundColor: "#1a1a1a",
};

const buttonStyle = {
  width: "100%",
  background: "#06402B",
  color: "#fff",
  fontWeight: 600,
  padding: "12px 0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 16,
  fontFamily: "Nexa-Bold",
};
